<template>
  <div class="row">
    <div class="col-12">
      <page-header :page="page" />
    </div>
    <div class="col-12 flip-cards-container">
      <square-option
        v-for="(option, index) in optionList"
        :key="index"
        :option="option"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PageHeader from 'PageHeader';
import SquareOption from '@/components/common/SquareOption.vue';
import { name as userModuleName } from '@/store/modules/user';
import navMenuTitles from '@/utils/constants/navMenuTitles';

export default {
  components: {
    SquareOption,
    PageHeader,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-cog',
        title: 'Proveedor',
        routes: ['Inicio', 'Proveedor'],
      },
    };
  },
  computed: {
    ...mapState(userModuleName, ['userMenu']),
    optionList() {
      return (
        this.userMenu
          .find((x) => x.title === navMenuTitles.Provider)
          ?.children.map((item) => ({
            title: item.title,
            description: item.description,
            detail: item.detail,
            icon: item.iconClasses,
            mainImage: item.mainImagePath,
            hoverImage: item.mainImageHoverPath,
            needSelectedStudent: item.needSelectedStudent,
            route: item.navigationPath,
          })) || []
      );
    },
  },
};
</script>
